const { createStore } = require('./Store');
const { LocationReducer } = require('./Reducers');
const { LocationState } = require('./States');
const { LocationActions } = require('./Actions');

const [LocationProvider, useLocationDispatch, useLocationStore] = createStore(
  LocationReducer,
  LocationState,
  LocationActions
);
export { LocationProvider, useLocationDispatch, useLocationStore };
